module.exports = __webpack_public_path__ + "img/gratitude-journal_B095KX6YWW.5acbd31d.jpg";